module.exports = __webpack_public_path__ + "img/packages20_mobile_banner.5f4e3bf4.png";